import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsVisible(true);
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Color mapping for categories
  const categoryColors: { [key: string]: string } = {
    'Days Out': 'bg-orange-100 text-orange-700',
    'Food & Drink': 'bg-green-100 text-green-700',
    'Cinema': 'bg-pink-100 text-pink-700',
    'Shopping': 'bg-teal-100 text-teal-700',
    'Accommodation': 'bg-cyan-100 text-cyan-700',
    'Holidays': 'bg-amber-100 text-amber-700',
    'Free': 'bg-emerald-100 text-emerald-700',
    'Rainy Days': 'bg-lime-100 text-lime-700',
    'Leisure Home Sales': 'bg-indigo-100 text-indigo-700',
  };

  const categories = [
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/b55bc53477280189f5fff24553115301.jpeg', title: 'Days Out' },
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/69a4006fc1e4871dc3a2db7f98b594b4.jpeg', title: 'Food & Drink' },
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/30e23378de361a3dd302eff396668749.jpeg', title: 'Cinema' },
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/91c058c4d1a83fada8818798724694a4.jpeg', title: 'Shopping' },
    { img: 'https://public.readdy.ai/ai/img_res/bb2407c6fe7c31d8fac758be198b849b.jpg', title: 'Accommodation' },
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/d59377f74014addc8690613529a64407.jpeg', title: 'Holidays' },
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/563e7055344a7364db7ad878f666f618.jpeg', title: 'Rainy Days' },
    { img: 'https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/881d964353993eacde84274de425eae6.jpeg', title: 'Leisure Home Sales' }
  ];

  const handleCategoryClick = (category: string) => {
    // Map category names to match the filter names on seaside-offers page
    const categoryMap: Record<string, string> = {
      'Days Out': 'Days out',
      'Food & Drink': 'Food & Drink',
      'Cinema': 'Cinema',
      'Shopping': 'Shopping',
      'Accommodation': 'Accommodation',
      'Holidays': 'Holidays',
      'Free': 'Free',
      'Rainy Days': 'Rainy Days',
      'Leisure Home Sales': 'Leisure Home Sales'
    };
    
    const mappedCategory = categoryMap[category] || category;
    navigate('/seaside-offers', { state: { selectedCategory: mappedCategory } });
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className={`fixed w-full z-50 transition-all duration-500 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white shadow-md'}`}>
        <div className="container mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3 transform transition-transform duration-300 hover:scale-105">
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/659671df2896ffc0ce475e0437197503.png" 
                alt="Seaside Vouchers Logo" 
                className="h-16 w-16 object-contain"
              />
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e0d98287e8c9dc8abdecc58291257ecc.png" 
                alt="SEASIDE VOUCHERS Text" 
                className="h-12 object-contain"
              />
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Home</Link>
              <Link to="/how-it-works" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">How it works</Link>
              <Link to="/seaside-offers" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Seaside Vouchers App</Link>
              <Link to="/voucher-book" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Voucher Book</Link>
              <Link to="/leisure-home-sales" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Leisure Home Sales</Link>
              <Link to="/accommodation" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Accommodation</Link>
              <Link to="/contact" className="text-sm font-semibold text-gray-900 hover:text-orange-500 transition-all duration-300 whitespace-nowrap relative after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-orange-500 after:transition-all after:duration-300 hover:after:w-full">Contact us</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section id="home" className="relative flex items-center justify-center overflow-hidden pt-32 pb-20">
        {/* Background Gradient */}
        <div className="absolute inset-0 bg-gradient-to-t from-cyan-500 via-teal-400 to-yellow-300"></div>

        {/* Animated Decorative Elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full opacity-10 blur-3xl animate-pulse"></div>
          <div className="absolute bottom-10 right-20 w-80 h-80 bg-white rounded-full opacity-10 blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/3 w-48 h-48 bg-white rounded-full opacity-10 blur-2xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>
        
        <div className={`relative z-10 container mx-auto px-6 text-center w-full transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <h1 className="text-5xl md:text-7xl font-black mb-6 leading-tight drop-shadow-lg animate-fade-in">
            <span className="inline-block relative bg-gradient-to-b from-white from-70% to-orange-500 bg-clip-text text-transparent">
              Discover
            </span>
            <span className="text-white">{' - '}</span>
            <span className="inline-block relative bg-gradient-to-b from-white from-70% to-orange-500 bg-clip-text text-transparent">
              Enjoy
            </span>
            <span className="text-white">{' - '}</span>
            <span className="inline-block relative bg-gradient-to-b from-white from-70% to-orange-500 bg-clip-text text-transparent">
              Save
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-white/95 mb-2 max-w-3xl mx-auto font-semibold drop-shadow-md" spellCheck="false">
            SEASIDE VOUCHERS is dedicated to bringing you dozens of discounts on Zoo's, Theme Parks, Cinemas, Restaurants and more at our Great British Seaside.
          </p>
          <p className="text-xl md:text-2xl text-white/95 mb-4 max-w-3xl mx-auto font-semibold drop-shadow-md" spellCheck="false">
            It's never been easier to save with Seaside Vouchers!
          </p>
          
          {/* Partner Logos in Hero - Mobile Only */}
          <div className="flex items-center justify-center gap-4 mb-6 flex-wrap lg:hidden">
            <div className="bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg transform hover:scale-105 transition-transform duration-300">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2025/06/4.png" 
                alt="Partner Logo" 
                className="h-12 object-contain"
              />
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg transform hover:scale-105 transition-transform duration-300">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2025/06/3.png" 
                alt="Partner Logo" 
                className="h-12 object-contain"
              />
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg transform hover:scale-105 transition-transform duration-300">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2024/11/3-1-removebg-preview.png" 
                alt="Partner Logo" 
                className="h-12 object-contain"
              />
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2 shadow-lg transform hover:scale-105 transition-transform duration-300">
              <img 
                src="https://seasidevouchers.co.uk/wp-content/uploads/2025/06/1.png" 
                alt="Partner Logo" 
                className="h-12 object-contain"
              />
            </div>
          </div>

          <p className="text-white text-lg font-semibold mb-4 drop-shadow-md">
            Download now for FREE on your app store for FREE - No subscription
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8">
            <a href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" target="_blank" rel="noopener noreferrer" className="cursor-pointer transform hover:scale-110 transition-all duration-300 hover:drop-shadow-2xl">
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1726012800" 
                alt="Download on App Store" 
                className="h-14"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="cursor-pointer transform hover:scale-110 transition-all duration-300 hover:drop-shadow-2xl">
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Get it on Google Play" 
                className="h-14"
              />
            </a>
          </div>

          <div className="mt-8 mb-4">
            <p className="text-white text-base font-semibold mb-3 drop-shadow-md">
              Are you a business? Promote your services on Seaside Vouchers
            </p>
            <Link 
              to="/business-registration"
              className="inline-block bg-orange-500 text-white px-10 py-4 rounded-full font-bold text-lg hover:bg-orange-600 transition-all duration-300 transform hover:scale-105 hover:-translate-y-1 shadow-xl hover:shadow-2xl cursor-pointer whitespace-nowrap"
            >
              JOIN SEASIDE VOUCHERS
            </Link>
          </div>
        </div>

        {/* Wave decoration at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
            <path d="M0,64 C240,96 480,96 720,64 C960,32 1200,32 1440,64 L1440,120 L0,120 Z" fill="white"/>
          </svg>
        </div>
      </section>

      {/* Categories Section */}
      <section className="py-16 bg-gradient-to-b from-cyan-50 to-white relative">
        <div className="container mx-auto px-6">
          
          {/* Section Heading */}
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-3">Discover Amazing Savings Across All Categories</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">Browse through our exclusive offers and start saving on your next seaside adventure</p>
          </div>

          {/* Carousel Container */}
          <div className="relative overflow-hidden">
            {/* Gradient overlays for fade effect */}
            <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-cyan-50 to-transparent z-10 pointer-events-none"></div>
            <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-cyan-50 to-transparent z-10 pointer-events-none"></div>
            
            {/* Scrolling container */}
            <div className="flex animate-category-scroll">
              {/* First set of categories */}
              <div className="flex gap-6 shrink-0">
                {categories.map((item, index) => (
                  <div 
                    key={`first-${index}`}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer flex-shrink-0 transform hover:scale-105 hover:-translate-y-2 group"
                    style={{ width: 'calc((100vw - 96px) / 5 - 19.2px)', minWidth: '200px', maxWidth: '280px' }}
                    onClick={() => handleCategoryClick(item.title)}
                  >
                    <div className="h-48 w-full overflow-hidden relative">
                      <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                    <div className="p-6 text-center">
                      <p className="text-xl font-bold text-orange-500 mb-3 transition-colors duration-300 group-hover:text-orange-600">SAVE ON</p>
                      <span className={`inline-block px-4 py-2 text-base font-bold rounded-full transition-all duration-300 ${categoryColors[item.title] || 'bg-cyan-100 text-cyan-700'} group-hover:scale-110`}>
                        {item.title}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              
              {/* Duplicate set for seamless loop */}
              <div className="flex gap-6 shrink-0 ml-6">
                {categories.map((item, index) => (
                  <div 
                    key={`second-${index}`}
                    className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 cursor-pointer flex-shrink-0 transform hover:scale-105 hover:-translate-y-2 group"
                    style={{ width: 'calc((100vw - 96px) / 5 - 19.2px)', minWidth: '200px', maxWidth: '280px' }}
                    onClick={() => handleCategoryClick(item.title)}
                  >
                    <div className="h-48 w-full overflow-hidden relative">
                      <img src={item.img} alt={item.title} className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    </div>
                    <div className="p-6 text-center">
                      <p className="text-xl font-bold text-orange-500 mb-3 transition-colors duration-300 group-hover:text-orange-600">SAVE ON</p>
                      <span className={`inline-block px-4 py-2 text-base font-bold rounded-full transition-all duration-300 ${categoryColors[item.title] || 'bg-cyan-100 text-cyan-700'} group-hover:scale-110`}>
                        {item.title}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Wave decoration at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#dcfdf4"/>
          </svg>
        </div>
      </section>

      {/* How It Works */}
      <section id="how-it-works" className="py-16 bg-gradient-to-b from-green-50 to-white relative">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">WHY USE SEASIDE VOUCHERS</h2>
          <p className="text-center text-gray-600 mb-12 max-w-2xl mx-auto">
            Save money on your seaside adventures with our free app
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group">
              <div className="w-16 h-16 flex items-center justify-center mb-4 bg-orange-500 rounded-full transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-download-cloud-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Free Download</h3>
              <ul className="space-y-2 text-sm text-gray-700">
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-0.5"></i>
                  <span>No upfront payment</span>
                </li>
                <li className="flex items-start gap-2">
                  <i className="ri-check-line text-orange-500 mt-0.5"></i>
                  <span>No Subscription</span>
                </li>
              </ul>
              <a href="#start-saving" className="inline-block mt-4 text-orange-500 font-semibold text-sm hover:text-orange-600 cursor-pointer whitespace-nowrap transition-all duration-300 hover:translate-x-2">
                Get The APP Here →
              </a>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group">
              <div className="w-16 h-16 flex items-center justify-center mb-4 bg-cyan-500 rounded-full transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-map-pin-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Access discounts on the go</h3>
              <p className="text-sm text-gray-700">
                Start saving on your next trip to the Great British Seaside
              </p>
            </div>

            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group">
              <div className="w-16 h-16 flex items-center justify-center mb-4 bg-green-500 rounded-full transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-group-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Any One can use it</h3>
              <p className="text-sm text-gray-700">
                The whole family can download and use Seaside Vouchers. Some offers may vary on their age limit depending on the attraction
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-6 shadow-md hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 group">
              <div className="w-16 h-16 flex items-center justify-center mb-4 bg-purple-500 rounded-full transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                <i className="ri-ticket-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Vouchers can be used multiple times</h3>
              <p className="text-sm text-gray-700">
                Yes, that's right. You can use our offers as many times as you wish. Your on holiday, enjoy yourself!
              </p>
            </div>
          </div>
        </div>

        {/* Wave decoration at bottom */}
        <div className="absolute bottom-0 left-0 right-0">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#3b82f6"/>
          </svg>
        </div>
      </section>

      {/* Start Saving */}
      <section id="start-saving" className="py-12 bg-gradient-to-br from-blue-500 to-blue-600 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 bg-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 bg-white rounded-full animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="text-white text-center">
              <h2 className="text-3xl font-bold mb-4">START SAVING TODAY</h2>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-download-cloud-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1 text-left">Download App</h3>
                    <p className="text-sm text-white/90 text-left">Get started in minutes</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-search-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1 text-left">Browse Offers</h3>
                    <p className="text-sm text-white/90 text-left">Find local seaside deals</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-qr-code-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1 text-left">Redeem Vouchers</h3>
                    <p className="text-sm text-white/90 text-left">Simply show your phone at the venue</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-money-pound-circle-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1 text-left">Save Money</h3>
                    <p className="text-sm text-white/90 text-left">Enjoy exclusive discounts</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-repeat-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1 text-left">Use Multiple Times</h3>
                    <p className="text-sm text-white/90 text-left">Reuse vouchers as many times as you want</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-lg flex-shrink-0">
                    <i className="ri-notification-line text-lg"></i>
                  </div>
                  <div>
                    <h3 className="font-bold text-base mb-1 text-left">Stay Updated</h3>
                    <p className="text-sm text-white/90 text-left">Get notified about new offers instantly</p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row gap-3 justify-center">
                <a href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" target="_blank" rel="noopener noreferrer" className="cursor-pointer transform hover:scale-105 transition-transform">
                  <img 
                    src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1726012800" 
                    alt="Download on App Store" 
                    className="h-12"
                  />
                </a>
                <a href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="cursor-pointer transform hover:scale-105 transition-transform">
                  <img 
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                    alt="Get it on Google Play" 
                    className="h-12"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-16 bg-gradient-to-b from-cyan-50 to-white relative">
        <div className="container mx-auto px-6 relative z-10">
          <h2 className="text-4xl font-bold text-center text-gray-900 mb-4">Frequently Asked Questions</h2>
          <p className="text-center text-gray-600 mb-12">
            Are you unable to locate what you're seeking? The following FAQs could be useful. If not, do get in touch with us.
          </p>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-6xl mx-auto">
            <div className="space-y-4">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Questions about Seaside Voucher</h3>
              <FAQItem 
                question="WHAT IS SEASIDE VOUCHERS?" 
                answer="The Seaside Voucher app is a free download giving you access to money saving deals for the Lincolnshire Coast"
              />
              <FAQItem 
                question="WHAT IS INCLUDED?" 
                answer="Seaside Vouchers gives you money saving offers for cinema, attractions, dining, holidays, shopping and much more."
              />
              <FAQItem 
                question="CAN VOUCHERS BE USED MULTIPLE TIMES?" 
                answer="Yes, you can use them as many times as you want."
              />
              <FAQItem 
                question="WHAT DOES IT COST?" 
                answer="Absolutely nothing, we are a free app. We want to save you money on your next trip to the seaside."
              />
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Questions about Seaside Voucher</h3>
              <FAQItem 
                question="IS THERE A SUBSCRIPTION?" 
                answer="No subscription, just download and enjoy money saving offers"
              />
              <FAQItem 
                question="HOW DO I USE THE VOUCHERS?" 
                answer="With most businesses you simply show the voucher on the app on arrival. However, some businesses do allow online booking with the code supplied"
              />
              <FAQItem 
                question="HOW DO I RESET MY PASSWORD?" 
                answer="In the Seaside Voucher app simply go to SETTINGS and CHANGE PASSWORD and enter your new details"
              />
              <FAQItem 
                question="HOW DO I UPDATE MY DETAILS?" 
                answer="In the Seaside Voucher app simply click on your profile image, enter any new details and click UPDATE PROFILE"
              />
            </div>

            <div className="space-y-4">
              <h3 className="text-xl font-bold text-gray-900 mb-4">Questions about Seaside Voucher</h3>
              <FAQItem 
                question="CAN ANYONE USE THE VOUCHERS?" 
                answer="There is no age limit to who can download Seaside Vouchers. However, some offers may have their own age limit depending on the business."
              />
              <FAQItem 
                question="CAN I BOOK ONLINE?" 
                answer="Yes, many offers are pre-bookable using the online discount codes supplied."
              />
              <FAQItem 
                question="WHEN CAN I USE THE OFFERS?" 
                answer="Most of the offers can be used 7 days a week but please check each offers individual terms and conditions where you will see clearly any exclusions"
              />
              <FAQItem 
                question="HOW WILL I KNOW WHEN NEW OFFERS ARE AVAILABLE?" 
                answer="If you enable notifications in SETTINGS you will receive all new offers as they are uploaded straight to the app. You can see all new offers by simply clicking the bell in the app."
              />
            </div>
          </div>
        </div>

        {/* Wave decoration at bottom */}
        <div className="absolute bottom-0 left-0 right-0 pointer-events-none">
          <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full">
            <path d="M0 120L60 110C120 100 240 80 360 70C480 60 600 60 720 65C840 70 960 80 1080 85C1200 90 1320 90 1380 90L1440 90V120H1380C1320 120 1200 120 1080 120C960 120 840 120 720 120C600 120 480 120 360 120C240 120 120 120 60 120H0Z" fill="#f97316"/>
          </svg>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="py-12 bg-orange-500">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-white mb-6">Ready to Start Saving?</h2>
          <p className="text-xl text-white mb-8">Download the app now and enjoy exclusive seaside offers</p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="https://apps.apple.com/pk/app/seaside-vouchers-user/id6745555629" target="_blank" rel="noopener noreferrer" className="cursor-pointer transform hover:scale-110 transition-all duration-300">
              <img 
                src="https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/en-us?size=250x83&amp;releaseDate=1726012800" 
                alt="Download on App Store" 
                className="h-14"
              />
            </a>
            <a href="https://play.google.com/store/apps/details?id=com.jeuxdevelopers.SeasideUser&pcampaignid=web_share&pli=1" target="_blank" rel="noopener noreferrer" className="cursor-pointer transform hover:scale-110 transition-all duration-300">
              <img 
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png" 
                alt="Get it on Google Play" 
                className="h-14"
              />
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-cyan-500 text-white py-8">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-6">
            <div>
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/659671df2896ffc0ce475e0437197503.png" 
                alt="Seaside Vouchers" 
                className="h-20 w-20 transform hover:scale-110 transition-transform duration-300"
              />
              <img 
                src="https://static.readdy.ai/image/2b444193caba623045f9c59f793c0c65/e0d98287e8c9dc8abdecc58291257ecc.png" 
                alt="SEASIDE VOUCHERS" 
                className="h-10"
              />
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Quick Link</h4>
              <ul className="space-y-2 text-sm">
                <li><Link to="/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Home</Link></li>
                <li><Link to="/how-it-works" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">How it works</Link></li>
                <li><Link to="/seaside-offers" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Seaside offers</Link></li>
                <li><Link to="/voucher-book" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Voucher Book</Link></li>
                <li><Link to="/leisure-home-sales" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Leisure Home Sales</Link></li>
                <li><Link to="/accommodation" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Accommodation</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Company</h4>
              <ul className="space-y-2 text-sm">
                <li><a href="https://seasidevouchers.co.uk/privacy-policy/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Privacy &amp; cookie policy</a></li>
                <li><a href="https://seasidevouchers.co.uk/terms-conditions/" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">T&amp;C</a></li>
                <li><Link to="/contact" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Contact us</Link></li>
                <li><Link to="/business-registration" className="hover:text-orange-300 transition-all duration-300 cursor-pointer whitespace-nowrap hover:translate-x-1 inline-block">Add Your Business</Link></li>
              </ul>
            </div>

            <div>
              <h4 className="font-bold text-lg mb-4">Follow Us</h4>
              <div className="flex gap-4">
                <a href="https://www.facebook.com/people/seasidevouchers/61566031950810/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="https://www.instagram.com/seaside_vouchers/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-instagram-line text-xl"></i>
                </a>
                <a href="https://www.tiktok.com/@seasidevouchers" target="_blank" rel="noopener noreferrer" className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-full hover:bg-white/30 transition-all duration-300 cursor-pointer transform hover:scale-110 hover:-translate-y-1">
                  <i className="ri-tiktok-fill text-xl"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-4 text-center text-sm">
            <p>Copyright © 2023 Seaside Voucher, All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

function FAQItem({ question, answer }: { question: string; answer: string }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full px-4 py-3 text-left flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
      >
        <span className="font-semibold text-sm text-gray-900">{question}</span>
        <i className={`ri-arrow-${isOpen ? 'up' : 'down'}-s-line text-xl text-orange-500 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}></i>
      </button>
      {isOpen && (
        <div className="px-4 py-3 bg-gray-50 text-sm text-gray-700 border-t border-gray-100 animate-fade-in">
          {answer}
        </div>
      )}
    </div>
  );
}
